const ExperienceLevelIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M0 12C0 5.37258 5.37258 0 12 0H36C42.6274 0 48 5.37258 48 12V36C48 42.6274 42.6274 48 36 48H12C5.37258 48 0 42.6274 0 36V12Z"
        fill="#85C553"
      />
      <path
        d="M16.0117 16.6668C16.0117 13.7255 18.4037 11.3335 21.3451 11.3335C24.2864 11.3335 26.6784 13.7255 26.6784 16.6668C26.6784 19.6082 24.2864 22.0002 21.3451 22.0002C18.4037 22.0002 16.0117 19.6082 16.0117 16.6668ZM25.4663 33.0934C24.7463 32.4134 24.4796 31.4001 24.7863 30.4534C25.093 29.4935 25.9064 28.8135 26.8931 28.6802L28.5597 28.4401C28.5597 28.4401 28.8264 28.4148 28.9064 28.2534L29.4396 27.1868C29.4396 27.1868 29.5063 27.0801 29.493 26.9334C29.4797 26.8801 29.4531 26.8002 29.3864 26.7336C28.2264 25.4936 26.4797 24.6668 23.9997 24.6668H18.6663C13.253 24.6668 11.333 28.6269 11.333 32.0269C11.333 35.0669 12.9463 36.6668 15.9997 36.6668H26.1196C26.333 36.6668 26.469 36.5068 26.533 36.1602L26.7996 34.6268C26.8263 34.4935 26.7864 34.3601 26.6797 34.2668L25.4663 33.0934ZM37.1556 31.6522C37.5089 31.3162 37.3143 30.7282 36.8276 30.6589L34.1717 30.2816C33.9784 30.2536 33.8103 30.1349 33.7249 29.9629L32.5744 27.6802C32.341 27.2175 31.6677 27.2175 31.4344 27.6802L30.2837 29.9629C30.197 30.1349 30.0304 30.2536 29.8371 30.2816L27.181 30.6589C26.6943 30.7282 26.4997 31.3162 26.853 31.6522L28.7729 33.4842C28.913 33.6175 28.977 33.8108 28.9437 34.0002L28.505 36.5055C28.4157 37.0149 28.9611 37.4042 29.4277 37.1642L31.7303 35.9801C31.9036 35.8908 32.1091 35.8908 32.2824 35.9801L34.5863 37.1655C35.0516 37.4055 35.5956 37.0175 35.5077 36.5081L35.0677 34.0002C35.0344 33.8108 35.0983 33.6175 35.2383 33.4842L37.1556 31.6522Z"
        fill="#F3F9EE"
      />
    </svg>
  );
};

export default ExperienceLevelIcon;
